export class EmailTemplate {
    public idMessageTemplate: string;
    public action: string="";
    public idLocale: number;
    public templateId: string;
    public messageType: string;
    public title: string;
    public body: string;
    public isDeleted: boolean;
}


// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/model/email.model.ts